export class PaymentRequest {
  constructor(id, externalId, paymentMethod, status) {
    this.id = id
    this.external_id = externalId
    this.payment_method = paymentMethod
    this.status = status
  }
}
